/** Apenas dígitos, até 8 (CEP Brasil). */
export function cepDigits(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 8);
}

/** Máscara 00000-000 */
export function formatCep(value) {
  const d = cepDigits(value);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

/**
 * Extrai CEP de texto livre (fallback alinhado à API).
 * @param {string|null|undefined} text
 * @returns {string} 8 dígitos ou ''
 */
export function extractCepFromAddressText(text) {
  const t = String(text || '').trim();
  if (!t) return '';
  let m = t.match(/\bCEP\s*[:\-]?\s*(\d{5})[\- ]?(\d{3})\b/i);
  if (m) return m[1] + m[2];
  m = t.match(/\b(\d{5})[\- ](\d{3})\b/);
  if (m) return m[1] + m[2];
  m = t.match(/\b(\d{8})\b/);
  if (m && cepDigits(m[1]).length === 8) return cepDigits(m[1]);
  return '';
}

/**
 * CEP para frete: campo explícito → coluna morada → texto.
 * @param {{ cep?: string, endereco?: string, cep_column?: string|null }} opts
 */
export function resolveCheckoutCepDigits(opts = {}) {
  const fromField = cepDigits(opts.cep);
  if (fromField.length === 8) return fromField;
  const fromCol = cepDigits(opts.cep_column);
  if (fromCol.length === 8) return fromCol;
  return extractCepFromAddressText(opts.endereco);
}
